/* eslint-disable */

const STORAGE_KEY = 'meya.scrollToTopOnNavigate';
export const SCROLL_TO_TOP_ON_NAVIGATE_CHANGE_EVENT = 'meya:scrollToTopOnNavigateChange';

function parseEnvFlag(value, defaultValue) {
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }
  const normalized = String(value).trim().toLowerCase();
  if (['0', 'false', 'no', 'off'].includes(normalized)) {
    return false;
  }
  if (['1', 'true', 'yes', 'on'].includes(normalized)) {
    return true;
  }
  return defaultValue;
}

export function getScrollToTopOnNavigateDefault() {
  return parseEnvFlag(process.env.REACT_APP_SCROLL_TO_TOP_ON_NAVIGATE, true);
}

export function isScrollToTopOnNavigateEnabled() {
  if (typeof window !== 'undefined') {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored === 'true') {
      return true;
    }
    if (stored === 'false') {
      return false;
    }
  }
  return getScrollToTopOnNavigateDefault();
}

export function setScrollToTopOnNavigateEnabled(enabled) {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  window.dispatchEvent(new CustomEvent(SCROLL_TO_TOP_ON_NAVIGATE_CHANGE_EVENT));
}

export function clearScrollToTopOnNavigateOverride() {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(SCROLL_TO_TOP_ON_NAVIGATE_CHANGE_EVENT));
}

export function getScrollToTopOnNavigateConfig() {
  if (typeof window !== 'undefined') {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored === 'true' || stored === 'false') {
      return {
        enabled: stored === 'true',
        source: 'sessionStorage',
        defaultEnabled: getScrollToTopOnNavigateDefault(),
      };
    }
  }
  return {
    enabled: getScrollToTopOnNavigateDefault(),
    source: 'env',
    defaultEnabled: getScrollToTopOnNavigateDefault(),
  };
}

if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  window.meyaScrollToTop = {
    enable: () => setScrollToTopOnNavigateEnabled(true),
    disable: () => setScrollToTopOnNavigateEnabled(false),
    reset: () => clearScrollToTopOnNavigateOverride(),
    status: () => getScrollToTopOnNavigateConfig(),
  };
}
